module.exports = __webpack_public_path__ + "static/media/Teresa_Segismundo.c119ccb3.jpg";